import styled, { css } from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const Sidebar = styled.aside`
	position: sticky;
	top: 0;
	grid-column: 1;
	grid-row: 2;
	height: 100%;
	max-height: 100%;
	min-height: 0;
	background: #0a0a0b;
	border-right: 1px solid ${THEME.line};
	display: flex;
	flex-direction: column;
	align-items: center;
	z-index: 5;
	padding: 18px 14px 16px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		position: fixed;
		inset: auto 0 0 0;
		width: 100%;
		height: calc(${THEME.mobileNavHeight} + env(safe-area-inset-bottom, 0px));
		display: flex;
		flex-direction: row;
		align-items: stretch;
		justify-content: center;
		border-right: 0;
		border-top: 1px solid ${THEME.line};
		padding:
			0
			max(6px, env(safe-area-inset-right, 0px))
			env(safe-area-inset-bottom, 0px)
			max(6px, env(safe-area-inset-left, 0px));
		box-sizing: border-box;
	}
`;

export const SidebarLanguageSlot = styled.div`
	margin-top: auto;
	width: 100%;
	display: flex;
	justify-content: center;

	@media (max-width: 760px) {
		display: none;
	}
`;

export const SideNav = styled.nav`
	width: 100%;
	display: grid;
	gap: 10px;
	padding-top: 0;

	@media (max-width: 760px) {
		flex: 1;
		height: ${THEME.mobileNavHeight};
		min-height: ${THEME.mobileNavHeight};
		align-self: flex-start;
		grid-template-columns: repeat(5, 1fr);
		align-items: center;
		gap: 0;
		padding: 0;
	}
`;

export const NavIcon = styled.span`
	width: 38px;
	height: 38px;
	display: grid;
	place-items: center;
	color: #aaa5ad;
	background: transparent;
	border: 0;
	line-height: 1;
	text-shadow: none;

	svg {
		display: block;
		width: 27px;
		height: 27px;
		fill: none;
		stroke: currentColor;
		stroke-width: 1.85;
		stroke-linecap: round;
		stroke-linejoin: round;
	}

	@media (max-width: 760px) {
		width: 32px;
		height: 32px;

		svg {
			width: 24px;
			height: 24px;
		}
	}
`;

export const NavLabel = styled.span`
	max-width: 72px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 0.68rem;

	@media (max-width: 760px) {
		display: none;
	}
`;

export const NavButton = styled.button`
	width: 100%;
	min-height: 66px;
	border: 0;
	border-radius: 18px;
	background: transparent;
	color: #bcb4c3;
	display: grid;
	grid-template-columns: 1fr;
	justify-items: center;
	align-items: center;
	gap: 4px;
	padding: 8px 6px;
	text-align: center;
	font-family: ${THEME.fontApp};
	font-weight: 500;
	transition:
		background 160ms ease,
		color 160ms ease,
		text-shadow 160ms ease,
		box-shadow 160ms ease;

	&:hover {
		color: #f6eaff;
		background: rgba(255, 255, 255, 0.025);
		text-shadow: 0 0 12px rgba(255, 77, 242, 0.34);
	}

	${(props) =>
		props.$active &&
		css`
			background: transparent;
			color: #ffffff;
			text-shadow:
				0 0 10px rgba(255, 255, 255, 0.24),
				0 0 22px rgba(255, 77, 242, 0.62);
			box-shadow: none;

			${NavIcon} {
				color: #a443ff;
				background: transparent;
				filter: drop-shadow(0 0 9px rgba(176, 38, 255, 0.95));
			}

			${NavLabel} {
				color: #c680ff;
			}
		`}

	@media (max-width: 760px) {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: ${THEME.mobileNavHeight};
		height: ${THEME.mobileNavHeight};
		gap: 0;
		border-radius: 8px;
		padding: 0;
	}
`;
